import React from "react";
import { Box } from "app/components/common";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

interface IProps {
  leftComponent: React.ReactElement;
  rightComponent: React.ReactElement;
}

const WebAnalysisBoxing = ({
  leftComponent = <></>,
  rightComponent = <></>,
}: IProps) => {
  if (isWebDesktop) {
    return (
      <Box
        flex={1}
        flexDirection="row"
        backgroundColor="neutral.white"
        borderRadius={8}
      >
        <Box flex={1} borderRadius={{ phone: 0, smallWeb: "inherit" }}>
          {leftComponent}
        </Box>
        <Box
          borderRightColor="neutral.100"
          borderRightWidth={1}
          height="100%"
        />
        <Box flex={1} borderRadius={{ phone: 0, smallWeb: "inherit" }}>
          {rightComponent}
        </Box>
      </Box>
    );
  }
  return leftComponent;
};

export default WebAnalysisBoxing;
